export async function convertFileToBlobAndDownload(file: string, name: string) {
  const blob = await fetch(file).then((r) => r.blob())
  const url = URL.createObjectURL(blob)
  downloadFile(url, name)
  // Add a small delay to ensure download has started
  await new Promise(resolve => setTimeout(resolve, 100))
}

export function downloadFile(url: string, filename?: string) {
  const link = document.createElement('a')

  link.href = url
  link.download = filename || ''

  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(url)
}
